/* eslint-disable max-lines */
import React, { Fragment, useEffect, useState } from 'react'
import { navigate } from '@reach/router'
import { array, bool, element, func, object, oneOfType, string } from 'prop-types'
import styled from 'styled-components'
import Toast from '@taglivros/oef_componentes/build/components/toast'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'

import ModalPix from '../../../components/ModalPix/ModalPix'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { useGlobal } from '../../../contexts/GlobalContext'
import { PixProvider } from '../../../contexts/PixContext'
import {
  BOTAO_GERAR_PIX,
  ETAPA_CONCLUSAO,
  ETAPA_PAGAMENTO,
  ETAPA_PLANO,
  mensagemSucessoFluxoPagamento,
  POSSIVEIS_ROTAS_FLUXOS_PAGAMENTO,
  TIPOS_FLUXO_BRINDES } from '../constantsFluxosPagamento'
import {
  MODALIDADE_CURADORIA,
  EVENTOS_GA,
  METODO_PAGAMENTO_PIX,
  METODO_PAGAMENTO_CARTAO,
  EVENTOS_PIXEL
} from '../../../constants'
import { isEmptyObject, goToTop, objetoTemPropriedade } from '../../../utils/helpers/helpers'
import { enviaEventoGA } from '../../../utils/helpers/helpersGA'
import { navigateParaHome } from '../../../utils/rotas/navigate'
import ReactPixel from 'react-facebook-pixel'

const WrapperBotaoFluxosPagamento = styled.div`
  margin-top: 10px;

  @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;

    & > button:not(:last-of-type) {
      margin-right: 10px;
    }
  }

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    display: flex;
    flex-direction: column-reverse;


    & > button:last-of-type {
      margin-bottom: 10px;
    }
  }
`

const ValidacaoFluxosPagamento = ( {
  acaoAdicionalBotaoProximo,
  children,
  concluirFluxo,
  dadosRetornoRequisicao,
  etapaAtual,
  labelBotaoUltimaEtapa,
  location,
  loadingRequisicao,
  planoExterno,
  primeiraEtapa,
  tipoFluxo
} ) => {
  const {
    dadosEtapas,
    etapaAtiva,
    etapas,
    errosDadosEtapas,
    modalidadeId,
    setEtapaAtiva,
    setEtapas,
    setarDadosEtapas,
    setarErrosDadosEtapas,
    setarPlanoInicial
  } = useFluxosPagamento()
  const {
    actionGA,
    actionVoltarGA,
    fluxoGA,
    getDadosGlobaisAssociado,
    rotaAtual,
    setActionGA,
    setActionVoltarGA,
    setToastGeral,
    setRotaAtual,
    validCaptcha,
  } = useGlobal()
  const [ permitirConclusaoFluxo, setPermitirConclusaoFluxo ] = useState( false )
  const [ tipoPagamento, setTipoPagamento ] = useState()
  const [ modalPix, setModalPix ] = useState( false )
  const [ baixouPix, setBaixouPix ] = useState( false )
  const [ respostaAcao, setRespostaAcao ] = useState( false )
  const temEtapas = !isEmptyObject( etapas )

  const proximaEtapa = () => {
    const anterior = etapas && Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva - 1 )
    const proxima = etapas && Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva + 1 )

    if ( anterior && isEmptyObject( dadosEtapas[ anterior.identificador ] ) && primeiraEtapa !== rotaAtual ) {
      setarErrosDadosEtapas( `Os dados da etapa ${anterior.visualizacao} estão incompletos. Complete-os para seguir em frente.` )
    } else {
      setEtapaAtiva( etapaAtiva + 1 )
      setEtapas( prevEtapas => ( {
        ...prevEtapas,
        [ etapaAtual.identificador ]: {
          ...prevEtapas[ etapaAtual.identificador ],
          'completo': true
        }
      } ) )
      navigate( proxima.url )
    }

    if ( etapaAtual.identificador === ETAPA_PAGAMENTO && !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) && !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) ) {
      const isPagamentoPix = dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento === METODO_PAGAMENTO_PIX.slug

      if ( isPagamentoPix ) {
        const novoObjetoPlano = {
          ...dadosEtapas[ ETAPA_PLANO ],
          ...dadosEtapas[ ETAPA_PAGAMENTO ].plano
        }
        setarDadosEtapas(
          novoObjetoPlano,
          ETAPA_PLANO
        )
      }
    }
  }

  const etapaAnterior = () => {
    if ( temEtapas && primeiraEtapa !== rotaAtual ) {
      const anterior = etapas && Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva - 1 )
      setEtapaAtiva( etapaAtiva - 1 )
      navigate( anterior.url )
    }

    if ( etapaAtual.identificador === ETAPA_CONCLUSAO ) {
      setarDadosEtapas(
        {},
        ETAPA_CONCLUSAO
      )
    }

    enviaEventoGA(
      fluxoGA,
      actionVoltarGA
    )
  }

  const acaoDepoisSucessoRequisicao = async() => {
    if ( !isEmptyObject( dadosRetornoRequisicao ) && tipoFluxo ) {
      const { pagamento } = dadosRetornoRequisicao
      const isPagamentoPix = !isEmptyObject( pagamento.pix )
      const mensagemSucesso = mensagemSucessoFluxoPagamento( TIPOS_FLUXO_BRINDES[ tipoFluxo ] )
      if ( tipoFluxo === 'renovação de plano' ) {
        await getDadosGlobaisAssociado( 'anual' )
      } else {
        await getDadosGlobaisAssociado( )
      }
      navigateParaHome( true )

      let metodoPagamentoInicial = METODO_PAGAMENTO_CARTAO.inicial
      if ( isPagamentoPix ) {
        metodoPagamentoInicial = METODO_PAGAMENTO_PIX.inicial
      }

      setToastGeral( {
        'mensagem': mensagemSucesso[ metodoPagamentoInicial ],
        'show': true,
        'tipoToast': Toast.SUCCESS
      } )
      goToTop()
    }
  }

  const funcaoBotaoAvancar = async() => {
    if ( permitirConclusaoFluxo && !isEmptyObject( dadosEtapas ) ) {
      await concluirFluxo( dadosEtapas )
    } else if ( acaoAdicionalBotaoProximo ) {
      const responseAcaoAdicional = await acaoAdicionalBotaoProximo()
      if ( responseAcaoAdicional ) {
        setRespostaAcao( responseAcaoAdicional )
      }
    } else {
      proximaEtapa()
    }

    enviaEventoGA(
      fluxoGA,
      actionGA
    )
    if ( etapaAtual.identificador === ETAPA_CONCLUSAO ) {
      ReactPixel.trackCustom( EVENTOS_PIXEL[ fluxoGA ], )
    }
  }

  const exibeLabelBotaoUltimaEtapa = () => {
    if ( tipoPagamento === METODO_PAGAMENTO_PIX.slug ) {
      return BOTAO_GERAR_PIX
    }
    return labelBotaoUltimaEtapa
  }

  useEffect(
    () => {
      if ( !isEmptyObject( location ) && objetoTemPropriedade(
        location,
        'pathname'
      ) ) {
        const paths = location.pathname.split( '/' )
        const path = paths[ paths.length - 1 ]
        setRotaAtual( path )
      }
    },
    [ location ]
  )

  useEffect(
    () => {
      if ( respostaAcao ) {
        proximaEtapa()
      }
    },
    [ respostaAcao ]
  )

  useEffect(
    () => {
      if ( Object.keys( dadosEtapas )[ 0 ] !== ETAPA_PLANO && !isEmptyObject( planoExterno ) ) {
        setarDadosEtapas(
          planoExterno,
          ETAPA_PLANO
        )
      }
    },
    [ planoExterno ]
  )

  useEffect(
    () => {
      if ( POSSIVEIS_ROTAS_FLUXOS_PAGAMENTO.includes( rotaAtual ) ) {
        if ( isEmptyObject( dadosEtapas ) && primeiraEtapa !== rotaAtual ) {
          navigate( primeiraEtapa )
        }
      }
    },
    [ location, rotaAtual ]
  )

  useEffect(
    () => {
      if ( !isEmptyObject( dadosEtapas[ etapaAtual.identificador ] ) ) {
        setarErrosDadosEtapas(
          '',
          etapaAtual.identificador
        )
      } else {
        setarErrosDadosEtapas(
          `Etapa ${etapaAtual.visualizacao} não preenchida`,
          etapaAtual.identificador
        )
      }

      if ( !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && etapaAtual.identificador === ETAPA_PLANO ) {
        setarPlanoInicial( dadosEtapas[ ETAPA_PLANO ] )
      }

      if ( !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) && etapaAtual.identificador === ETAPA_CONCLUSAO ) {
        setTipoPagamento( dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento )
      }
    },
    [ dadosEtapas ]
  )

  useEffect(
    () => {
      if ( etapaAtual.identificador === ETAPA_CONCLUSAO && dadosEtapas[ ETAPA_CONCLUSAO ] && dadosEtapas[ ETAPA_CONCLUSAO ].isConclusaoPreenchida ) {
        setPermitirConclusaoFluxo( true )
      }
    },
    [ dadosEtapas, etapas ]
  )

  useEffect(
    () => {
      if ( !isEmptyObject( dadosRetornoRequisicao ) ) {
        const { pagamento } = dadosRetornoRequisicao
        if ( !isEmptyObject( pagamento.pix ) ) {
          setModalPix( true )
        } else {
          acaoDepoisSucessoRequisicao()
        }
      }
    },
    [ dadosRetornoRequisicao ]
  )

  useEffect(
    () => {
      if ( baixouPix ) {
        setModalPix( false )
      }
    },
    [ baixouPix ]
  )

  useEffect(
    () => {
      const passoAnterior = etapas && Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva - 1 )

      if ( passoAnterior ) {
        setActionVoltarGA( EVENTOS_GA[ fluxoGA ].ACOES_VOLTAR[ passoAnterior.identificador ] )
      }

      setActionGA( EVENTOS_GA[ fluxoGA ].ACOES[ etapaAtual.identificador ] )
    },
    []
  )

  return (
    <Fragment>
      { children }

      { modalPix ?
        <PixProvider>
          <ModalPix
            acaoPosGerarPix={ () => acaoDepoisSucessoRequisicao() }
            dadosPix={ !isEmptyObject( dadosRetornoRequisicao ) && dadosRetornoRequisicao.pagamento.pix }
            setBaixouPix={ () => setBaixouPix( true ) }
            showModal={ modalPix }
            toggleModal={ () => setModalPix( false ) }
          />
        </PixProvider> : null}

      <WrapperBotaoFluxosPagamento>
        { primeiraEtapa !== rotaAtual &&
          <Button
            className="custom-margin"
            disabled={ Boolean( primeiraEtapa === rotaAtual ) }
            fullWidth={ StyleGuide.isMobile() }
            invertido
            onClick={ etapaAnterior }
            tema={ modalidadeId === MODALIDADE_CURADORIA.id ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
          >
            Voltar
          </Button> }

        <Button
          disabled={ Boolean( errosDadosEtapas[ etapaAtual.identificador ] ) || loadingRequisicao || ( !validCaptcha && etapaAtual.identificador === ETAPA_PAGAMENTO ) }
          fullWidth={ StyleGuide.isMobile() }
          hasSpaceBottom={ !StyleGuide.isMobile() }
          onClick={ funcaoBotaoAvancar }
          tema={ modalidadeId === MODALIDADE_CURADORIA.id ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
          testId="continuar"
        >
          { exibeLabelBotaoUltimaEtapa() }
        </Button>
      </WrapperBotaoFluxosPagamento>
    </Fragment>
  )
}

ValidacaoFluxosPagamento.defaultProps = {
  'acaoAdicionalBotaoProximo': null,
  'concluirFluxo': null,
  'dadosRetornoRequisicao': null,
  'labelBotaoUltimaEtapa': 'Continuar',
  'planoExterno': null,
  'tipoFluxo': null
}

ValidacaoFluxosPagamento.propTypes = {
  'acaoAdicionalBotaoProximo': func,
  'children': oneOfType( [ array, element ] ).isRequired,
  'concluirFluxo': func,
  'dadosRetornoRequisicao': object,
  'etapaAtual': object.isRequired,
  'labelBotaoUltimaEtapa': string,
  'loadingRequisicao': bool.isRequired,
  'location': object.isRequired,
  'modalidade': string.isRequired,
  'planoExterno': object,
  'primeiraEtapa': string.isRequired,
  'respostaRequisicao': bool.isRequired,
  'tipoFluxo': string
}

export default ValidacaoFluxosPagamento
